import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuardService } from './services/guard-services/admin-guard.service';
import { FormGuardService } from './services/guard-services/form-guard.service';
import { HealthMemberGuardService } from './services/guard-services/health-member-guard.service';
import { IgestoAdminGuardService } from './services/guard-services/igesto-admin-guard.service';
import { PatientGuardService } from './services/guard-services/patient-guard.service';
import { PrivacyPoliceComponent } from './shared/pages/privacy-police/privacy-police.component';
import { TrialAgreementComponent } from './shared/pages/trial-agreement/trial-agreement.component';
import { MemberGuardService } from './services/guard-services/member-guard.service';
import { LoggedGuardService } from './services/guard-services/logged-guard.service';
import { PrivacyPolicePreventionComponent } from './shared/pages/privacy-police-prevention/privacy-police-prevention.component';

const routes: Routes = [
  {
    path: 'signIn',
    pathMatch: 'full',
    loadChildren: () =>
      import('./pages/tamis-access/tamis-login/tamis-login.module').then(
        (m) => m.TamisLoginModule
      ),
  },
  {
    path: 'signUp',
    loadChildren: () =>
      import('./pages/tamis-access/tamis-register/tamis-register.module').then(
        (m) => m.TamisRegisterModule
      ),
  },
  {
    path: 'user-action',
    loadChildren: () =>
      import('./pages/user-actions/user-actions.module').then(
        (m) => m.UserActionsModule
      ),
  },
  {
    path: 'planosCuidados',
    loadChildren: () =>
      import('./pages/form-fill-management/form-fill-management.module').then(
        (m) => m.FormFillManagementModule
      ),
  },
  {
    path: 'api/visita',
    loadChildren: () =>
      import('./pages/form-fill-management/form-fill-management.module').then(
        (m) => m.FormFillManagementModule
      ),
  },
  {
    path: 'privacy',
    component: PrivacyPoliceComponent,
  },
  {
    path: 'trial_agreement',
    component: TrialAgreementComponent,
  },
  {
    path: 'guide/start_here',
    loadChildren: () =>
      import('./shared/doctors-start-here/tamis-eii-start-here.module').then((m) => m.TamisEiiStartHereModule),
    data: {
      title: 'Guia Inicial',
      secured: true
    }
  },
  {
    path: 'prevent',
    loadChildren: () =>
      import('./pages/prevent-calculator/prevent-calculator.module').then((m) => m.PreventCalculatorModule),
  },
  {
    path: 'policy-prevention/agreement',
    component: PrivacyPolicePreventionComponent,
  },
  {
    path: 'app',
    children: [
      {
        path: 'not-found',
        canActivate: [LoggedGuardService],
        loadChildren: () =>
          import('./shared/pages/not-found/not-found.module').then(
            (m) => m.NotFoundModule
          ),
      },
      {
        path: 'patient',
        canActivate: [PatientGuardService],
        loadChildren: () =>
          import('./pages/patient/patient.module').then((m) => m.PatientModule),
      },
      {
        path: 'first-access',
        canActivate: [LoggedGuardService],
        loadChildren: () =>
          import(
            './pages/tamis-access/tamis-first-access/tamis-first-access.module'
          ).then((m) => m.TamisFirstAccessModule),
      },
      {
        path: 'health-member',
        canActivate: [HealthMemberGuardService],
        loadChildren: () =>
          import('./pages/health-member/health-member.module').then(
            (m) => m.HealthMemberModule
          ),
      },
      {
        path: 'institution',
        canActivate: [IgestoAdminGuardService],
        loadChildren: () =>
          import('./pages/institution/institution.module').then(
            (m) => m.InstitutionModule
          ),
      },
      {
        path: 'medicine-prescription',
        canActivate: [MemberGuardService],
        loadChildren: () =>
          import(
            './pages/medicine-prescription/medicine-prescription.module'
          ).then((m) => m.MedicinePrescriptionModule),
      },
      {
        path: 'form',
        canActivate: [MemberGuardService],
        loadChildren: () =>
          import('./pages/form/form.module').then((m) => m.FormModule),
      },
      {
        path: 'dashboard',
        canActivate: [MemberGuardService],
        loadChildren: () =>
          import('./pages/dashboard/dashboard.module').then((m) => m.DashboardManagementModule),
      },
      {
        path: 'tamis-bot',
        canActivate: [MemberGuardService],
        loadChildren: () =>
          import('./pages/tamis-bot/tamis-bot.module').then((m) => m.TamisBotModule),
      },
      {
        path: 'form',
        children: [
          {
            path: '',
            canActivate: [FormGuardService],
            loadChildren: () =>
              import('./pages/form/form.module').then((m) => m.FormModule),
          },
        ],
      },
      {
        path: '',
        canActivate: [IgestoAdminGuardService],
        loadChildren: () =>
          import(
            './pages/configuration-management/configuration-management.module'
          ).then((m) => m.ConfigurationManagementModule),
      },
      {
        path: '',
        canActivate: [HealthMemberGuardService],
        loadChildren: () =>
          import('./pages/template-management/template-management.module').then(
            (m) => m.TemplateManagementModule
          ),
      },
      {
        path: '',
        canActivate: [MemberGuardService],
        loadChildren: () =>
          import(
            './pages/care-plan-management/care-plan-management.module'
          ).then((m) => m.CarePlanManagementModule),
      },
      {
        path: '',
        canActivate: [HealthMemberGuardService],
        loadChildren: () =>
          import(
            './pages/admin-configuration-management/admin-configuration-management.module'
          ).then((m) => m.AdminConfigurationManagementModule),
      },
      {
        path: '',
        canActivate: [HealthMemberGuardService],
        loadChildren: () =>
          import('./pages/trial-management/trial-management.module').then(
            (m) => m.TrialManagementModule
          ),
      },
    ],
  },
  {
    path: '',
    redirectTo: '/signIn',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/app/not-found',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
